import { TuiButtonModule } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './not-found-page.component.html',
  styleUrls: [ './not-found-page.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ RouterLink, TuiButtonModule ],
})
export class NotFoundPageComponent {}
